import { Controller } from "@hotwired/stimulus"

import { polyfill } from "@microsoft/focusgroup-polyfill"

// Connects to data-controller="polyfills--focus-group"
// rm after focusgroup gains native browser support
// https://developer.chrome.com/blog/focusgroup-rfc
export default class extends Controller {
  polyfill () {
    this.element
      .querySelectorAll("[focusgroup]")
      .forEach(el => this.constructor.observer.observe(el))
  }

  static observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target
      // polyfilling invisible elements doesn't work:
      //  - marks them as polyfilled
      //  - prevent them from polyfilling when they become visible
      if (el.checkVisibility()) {
        // console.log("polyfilling", el)
        polyfill(el)
      } else {
        // console.log("invisible, not polyfilling", el)
      }
    })
  })
}
